import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import classnames from 'classnames';
import { Link } from 'react-router-dom';

import {
    Button, Typography, withStyles,
} from '@material-ui/core';

import Header from './components/Header';
import Footer from './components/Footer';
import { VimoLink } from '../../common/components';
import urls from '../../app/urls';
import Auth from '../../youwell-common/Auth';

import frontImage from '../../common/image/Photo.jpg';
import tryButtonImage from '../../common/image/icon_elever.png';
import { Image } from '../../youwell-common/components';
import VideoListing from './components/VideoListing';
import PriceMatrix from './components/PriceMatrix';
import PublicTaskContent from './components/PublicTaskContent';
import HomeContent from './components/HomeContent';
import FaqContent from './components/Faq';
import { getStylesFromSettings } from '../../youwell-common/components/taskElements/TaskElement';

export const contentWidth = 1080;
export const contentLeftMargin = 200;
const headerHeight = 80;

const styles = theme => ({
    root: {
    },
    header: {
        top: 0,
        width: '100%',
        height: headerHeight,
    },
    content: {
        display: 'flex',
        justifyContent: 'center',
        background: theme.palette.common.white,
        padding: theme.spacing(8),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(6, 2, 3),
        },
    },
    blueWhite: {
        background: `linear-gradient(180deg, ${theme.colors.blue4} 0%, ${theme.colors.blue4} 44%, ${theme.palette.common.white} 44%, ${theme.palette.common.white} 100%)`,
        // color: theme.palette.common.white,

        [theme.breakpoints.down('xs')]: {
            background: `linear-gradient(180deg, ${theme.colors.blue4} 0%, ${theme.colors.blue4} 42%, ${theme.palette.common.white} 42%, ${theme.palette.common.white} 100%)`,
        },
    },
    grey: {
        background: theme.colors.grey2,
    },
    center: {
        width: '100%',
        maxWidth: contentWidth,

        [theme.breakpoints.down('xs')]: {
            minHeight: 0,
        },
    },
    firstContent: {
        position: 'relative',
        padding: 0,

        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
        },
    },
    frontImage: {
        width: '100%',
    },
    topContent: {
        position: 'absolute',
        width: contentWidth,
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',

        [theme.breakpoints.down(contentWidth)]: {
            width: '100%',
            justifyContent: 'center',
        },

        [theme.breakpoints.down('xs')]: {
            position: 'relative',
            left: '0',
            top: '0',
            transform: 'none',
        },
    },
    introBox: {
        width: '50%',

        [theme.breakpoints.down('xs')]: {
            width: '100%',
            marginBottom: theme.spacing(2),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
    },
    introText: {
        marginBottom: theme.spacing(2),
        padding: theme.spacing(1),
        background: '#ffffff7a',

        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(3),
        },
    },
    flexOnLarge: {
        display: 'flex',

        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
        },
    },
    leftMargin: {
        flex: `0 0 ${contentLeftMargin}px`,

        [theme.breakpoints.down('sm')]: {
            flex: `0 0 ${contentLeftMargin / 2}px`,
        },
        [theme.breakpoints.down('xs')]: {
            flex: '1 1 auto',
        },
    },
    bigButton: {
        width: 300,
        padding: theme.spacing(3),
        marginBottom: theme.spacing(1),

        [theme.breakpoints.down('xs')]: {
            width: 200,
        },
    },
    buttonSubText: {
        width: 300,
        textAlign: 'center',

        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },
    tryNow: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: theme.spacing(1),
    },
    tryButtonImage: {
        marginBottom: -25,
        zIndex: 1,
        pointerEvents: 'none',
    },
    bookMeeting: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(10),
    },
    bookMeetingButton: {
        background: theme.colors.green3,
        color: theme.palette.primary.main,
    },
    priceMatrix: {
        marginTop: theme.spacing(4),
    },
    twoColumn: {
        width: '50%',

        '&:first-child': {
            paddingRight: theme.spacing(2),
            [theme.breakpoints.down('sm')]: {
                paddingRight: 0,
            },
        },
        '&:last-child': {
            paddingLeft: theme.spacing(2),
            [theme.breakpoints.down('sm')]: {
                paddingLeft: 0,
            },
        },

        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    topHtmlContent: {
        '& figure.media': {
            marginRight: contentLeftMargin,

            [theme.breakpoints.down('sm')]: {
                marginRight: 50,
            },
            [theme.breakpoints.down('xs')]: {
                marginRight: 0,
            },
        },
        '& a': {
            color: theme.colors.green3,
        },
    },
    doubleLineHeight: {
        lineHeight: '2em',
    },
    loggedInBox: {
        width: 400,
        padding: theme.spacing(3),
        background: theme.colors.grey2,
    },
    loggedInName: {
        margin: theme.spacing(2, 0, 4),
    },
    priceContent: {
        color: theme.palette.primary.main,
        '& p': {
            marginBottom: '0.5em',
        },
    },
    faq: {
        marginTop: theme.spacing(6),
    },
});

class Home extends React.Component {
    render() {
        const {
            classes, translate, profileData, content,
        } = this.props;

        const isLoggedIn = Auth.isUserAuthenticated();

        return (
            <div className={classes.root}>
                <Header className={classes.header} />

                <div className={classnames(classes.content, classes.firstContent)}>
                    <Image src={frontImage} className={classes.frontImage} />
                    <div className={classes.topContent}>
                        {isLoggedIn && profileData ? (
                            <div className={classes.loggedInBox}>
                                <Typography variant="h6">
                                    {translate('frontpage.youAreLoggedIn')}
                                </Typography>
                                <Typography variant="subtitle2" className={classes.loggedInName}>
                                    {profileData.name}
                                </Typography>
                                <VimoLink
                                    to={urls.inside.home}
                                    text={translate('frontpage.goToInside')}
                                    forward
                                />
                            </div>
                        ) : (
                            <div className={classes.introBox}>
                                <Typography variant="subtitle1" color="secondary" className={classes.introText}>
                                    {translate('frontpage.aboutVimoShort')}
                                </Typography>
                                <Button component={Link} to={urls.register} color="primary" variant="contained" className={classes.bigButton}>
                                    {translate('frontpage.tryNow')}
                                </Button>
                                <Typography variant="h6" color="secondary" className={classes.buttonSubText}>
                                    {translate('frontpage.30DaysFreeTest')}
                                </Typography>
                            </div>
                        )}
                    </div>
                </div>

                <div id="about" className={classnames(classes.content, classes.blueWhite)} style={getStylesFromSettings(content[0]?.settings)}>
                    <div className={classnames(classes.center, classes.flexOnLarge)}>
                        <div className={classes.leftMargin} />
                        <div>
                            <Typography variant="h4" color="primary" gutterBottom>
                                {translate('frontpage.aboutVimo')}
                            </Typography>
                            <HomeContent task={content[0]} classes={{ htmlContent: classes.topHtmlContent }} />
                        </div>
                    </div>
                </div>

                <div id="price" className={classnames(classes.content, classes.grey)}>
                    <div className={classes.center}>
                        <PublicTaskContent task={content[1]} classes={{ htmlContent: classes.doubleLineHeight }} />

                        <PriceMatrix className={classes.priceMatrix} />

                        <PublicTaskContent task={content[2]} classes={{ htmlContent: classes.priceContent }} />

                        {!isLoggedIn && (
                            <div className={classes.tryNow}>
                                <Image src={tryButtonImage} className={classes.tryButtonImage} />
                                <Button component={Link} to={urls.register} color="secondary" variant="contained" className={classes.bigButton}>
                                    {translate('priceMatrix.startTrial')}
                                </Button>
                            </div>
                        )}
                        <div className={classes.bookMeeting}>
                            <Button component="a" href="https://meetings.engagebay.com/youwell" target="_blank" rel="noopener noreferrer" color="primary" variant="contained" className={classnames(classes.bigButton, classes.bookMeetingButton)}>
                                {translate('frontpage.talkToUs')}
                            </Button>
                        </div>

                    </div>
                </div>

                <div id="help" className={classes.content}>
                    <div className={classes.center}>
                        <VideoListing task={content[3]} />
                        <FaqContent task={content[7]} className={classes.faq} />
                    </div>
                </div>

                <div id="security" className={classnames(classes.content, classes.grey)}>
                    <div className={classnames(classes.center, classes.flexOnLarge)}>
                        <div className={classes.twoColumn}>
                            <PublicTaskContent showTitle task={content[4]} />
                        </div>
                        <div id="contact" className={classes.twoColumn}>
                            <PublicTaskContent showTitle task={content[5]} />
                        </div>
                    </div>
                </div>

                <Footer />
            </div>
        );
    }
}

Home.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    profileData: PropTypes.object,
    content: PropTypes.array.isRequired,
};

Home.defaultProps = {
    profileData: null,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    profileData: state.auth.profileData,
    appConfig: state.pageSettings.appConfig,
    content: (state.program.content && state.program.content[state.pageSettings.appConfig?.contentProgramId]?.modules?.find(d => d.id === state.pageSettings.appConfig?.frontpageModuleId)?.tasks) || [],
});

export default connect(mapStateToProps)(withStyles(styles)(Home));
